import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { EmptyActivityPanel } from '../../../components/empty-activity-panel'

function Bridge({ title, subtitle }) {
  return <EmptyActivityPanel title={title} subtitle={subtitle} />
}

export const reactEmptyActivityPanel = createNgReactBridgeDirective(
  'reactEmptyActivityPanel',
  [],
  Bridge,
  ['title', 'subtitle']
)
